export default "__VITE_ASSET__afdde4a3__"